module.exports = __webpack_public_path__ + "static/media/website.0b72660d.png";